import { combineReducers } from 'redux'
import _ from 'lodash'
import { reducers } from '@adc/ui-morpheus'
import {
  CLEAR_VENUES,
  UPDATE_VENUE_IN_LIST,
  UPDATE_BULK_UPDATED_VENUE_COUNT,
  CLEAR_BULK_UPDATED_VENUE_COUNT,
} from '../../constants/actionTypes'
import { VENUES } from '../../constants/tableTypes'
import { apiToUiDataRowTranslation } from '../../translations/venues'
import tableReducer from './columnDefinitions'

const initialState = {
  content: [],
  total_elements: 0,
  venuesUpdated: 0,
  venueCount: 0,
}

const venuesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_VENUES:
      return initialState
    case UPDATE_BULK_UPDATED_VENUE_COUNT:
      return {
        ...state,
        venuesUpdated: state.venuesUpdated + action.venuesUpdated,
        venueCount: action.venueCount,
      }
    case CLEAR_BULK_UPDATED_VENUE_COUNT:
      return {
        ...state,
        venuesUpdated: 0,
        venueCount: 0,
      }
    case UPDATE_VENUE_IN_LIST: {
      const updatedVenue = apiToUiDataRowTranslation(action.venue)
      if (
        state.total_elements > 0 &&
        state.content &&
        state.content.length > 0
      ) {
        const matchIndex = _.findIndex(state.content, {
          venue_id: updatedVenue.venue_id,
        })
        if (matchIndex > -1) {
          return {
            ...state,
            content: [
              ...state.content.slice(0, matchIndex),
              updatedVenue,
              ...state.content.slice(matchIndex + 1),
            ],
          }
        }
      }
      return state
    }
    default:
      return reducers.dataTable.tableFetchReducer(VENUES, state, action)
  }
}

const venuesDownloadReducer = (state = initialState, action) =>
  reducers.dataTable.downloadFetchReducer(VENUES, state, action)

export default combineReducers({
  data: venuesReducer,
  tableInfo: tableReducer,
  suggestions: (state, action) =>
    reducers.dataTable.suggestionsFetchReducer(VENUES, state, action),
  savedSearches: (state, action) =>
    reducers.dataTable.savedSearchesReducer(VENUES, state, action),
  downloadData: venuesDownloadReducer,
})
export { initialState, venuesReducer }
